import React from 'react';
import Rating from '@mui/material/Rating';
import ConsultationBtn from '@/components/resume/resume-marketing/ConsultationBtn';
import personAImage from '@/assets/resume-consult/person-a.svg';
import personBImage from '@/assets/resume-consult/person-b.svg';
import personCImage from '@/assets/resume-consult/person-c.svg';

const ConsultUser = () => {
  return (
    <div
      className="my-20 px-5 tablet:my-25"
      data-ele-id="content"
      data-ele-group="landing_值得信任的简历咨询服务"
      data-observer-id="landing_值得信任的简历咨询服务"
    >
      <div className="text-center">
        <p className="text-3.25xl font-semibold mb-3 tablet:text-4pxl">
          值得信任的简历咨询服务
        </p>
        <p className="text-lg text-black/65 mb-5">
          已服务数百求职者，广受一致好评
        </p>
        <ConsultationBtn dataEleGroup="landing_值得信任的简历咨询服务" />
      </div>
      <div className="flex gap-8 flex-col mt-14 items-center tablet:flex-row tablet:flex-nowrap tablet:justify-center tablet:items-start">
        <div className="w-full max-w-[358px] shrink-0 rounded-2.5xl px-5 py-7 text-center bg-white shadow-[0px_50px_80px_0px_#0000000d]">
          <span
            className="block w-14 h-14 mx-auto rounded-full bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url(${personAImage.src})` }}
          />
          <p className="my-2 text-lg font-semibold">王同学</p>
          <Rating value={5} readOnly />
          <p className="text-center mt-5 text-base text-black/70">
            此次简历咨询受益颇多，首先丰富了我的简历内容，其次让我的简历内容更有层次和逻辑；让我完全的展示了自己的优势，也让我打开了自己的思维，改完后吸引了很多HR主动沟通，真的非常棒！
          </p>
        </div>
        <div className="w-full max-w-[358px] shrink-0 rounded-2.5xl px-5 py-7 text-center bg-white shadow-[0px_50px_80px_0px_#0000000d]">
          <span
            className="block w-14 h-14 mx-auto rounded-full bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url(${personBImage.src})` }}
          />
          <p className="my-2 text-lg font-semibold">赵同学</p>
          <Rating value={5} readOnly />
          <p className="text-center mt-5 text-base text-black/70">
            非常有价值的沟通！老师从多个维度帮助我梳理和优化了简历，不仅清晰地展示了我的优势，还结合我的个人经历、能力和性格给出了中肯的求职建议。这对我的求职方向非常有帮助，受益匪浅
          </p>
        </div>
        <div className="w-full max-w-[358px] shrink-0 rounded-2.5xl px-5 py-7 text-center bg-white shadow-[0px_50px_80px_0px_#0000000d]">
          <span
            className="block w-14 h-14 mx-auto rounded-full bg-contain bg-no-repeat bg-center"
            style={{ backgroundImage: `url(${personCImage.src})` }}
          />
          <p className="my-2 text-lg font-semibold">安同学</p>
          <Rating value={5} readOnly />
          <p className="text-center mt-5 text-base text-black/70">
            专业老师对我的简历进行了详细评估和修改，特别是在研究能力、实践能力和展现能力方面。帮助我重新组织了教育和实习经历，强调了我的研究和行业分析经验、获奖经历及商业洞察能力，并提升了我的自我介绍部分。对各项经历也提供了针对具体内容的修改建议，更加细致有条理。十分感谢～
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConsultUser;
